import Container from '@/components/atoms/Container'
import Spinner from '@/components/atoms/Spinner'

export function Loader() {
	return (
		<div className='bg-zinc-950'>
			<Container className='flex flex-col gap-6 w-screen h-screen justify-end py-10 items-center'>
				<div className='flex flex-col justify-between w-full items-center h-3/5'>
					<div>
						<Spinner className='inline w-16 h-16 text-gray-200 animate-spin fill-brand-primary' />
					</div>
				</div>
			</Container>
		</div>
	)
}
